import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://www.gradatim.co.in";
const DEFAULT_TITLE =
  "Gradatim — Insurance Operating Platform for Life, Group & Embedded";
const DEFAULT_DESCRIPTION =
  "Gradatim is a unified insurance operating platform — policy administration, distribution, workflows, analytics and AI-driven operations for life, group and embedded insurance.";
const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

/**
 * Page-level <head> manager.
 *
 * Usage:
 *   <SEO
 *     title="MFInsure® Core — Gradatim"
 *     description="..."
 *     path="/products/core"
 *   />
 */
export const SEO = ({
  title,
  description,
  path,
  ogImage,
  noindex = false,
}) => {
  const location = useLocation();
  const pathname = path || location.pathname;
  const fullTitle = title
    ? title.includes("Gradatim")
      ? title
      : `${title} — Gradatim`
    : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESCRIPTION;
  const url = `${SITE_URL}${pathname}`;
  const image = ogImage || OG_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Gradatim" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};
